import React from "react"
import Button, { ButtonGroup } from "@kit/design/button"

export function GroupWrapper({ label, children, className = "text-sm " }) {
  return (
    <div className="w-full mb-1">
      <div className="pb-1">
        <label
          className={"font-semibold text-gray-700 nowrap w-full mb-0 "
            .concat(className)
            .trim()}
        >
          {label}
        </label>
      </div>
      {children}
    </div>
  )
}

export function RadioButtonGroup({
  keyName,
  options,
  update,
  currentValue,
  buttonGroupClasses = "w-full",
  buttonClasses = "text-gray-700 hover:text-gray-800 focus:text-gray-800",
  activeButtonClasses,
  spacing = 1,
  ...props
}) {
  // Prevents `undefined` options from being passed to ButtonGroup.
  const choices = options.filter(Boolean)

  return (
    <ButtonGroup spacing={spacing} className={buttonGroupClasses} {...props}>
      {choices.map(({ value, icon, text, func, label }) => {
        const handleClick = () => update(keyName, value)
        const classNames =
          currentValue === value || (!currentValue && !value)
            ? activeButtonClasses
            : buttonClasses
        return (
          <Button
            active={currentValue === value}
            className={`justify-center items-center leading-none focus:outline-none ${classNames}`}
            key={`${keyName}_${value}`}
            onClick={func || handleClick}
            aria-label={label}
            title={label}
          >
            {icon} {text}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}
